export default __webpack_public_path__ + "static/media/79.d232eab7.jpg";